import { useNavigate } from "react-router";
import { ACCEPT_TRANSACTION_URL, CLEAR_BASKET_URL, REMOVE_ITEM_BASKET_URL } from "../../../api/apiRoutes";
import { setSuccessMessage } from "../../../store/alerts/alertsActions";
import { useDispatch, useSelector } from "react-redux";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import useFacility from "../../../../utils/hooks/useFacility";
import { SALE_MOVIE_PAGE } from "../../../routes";
import { updateSelectedSeats } from "../../../store/basket/basketActions";
import { State } from "../../../store";
import { setSaveData } from "../../../models/SaveData";
import { InputsFinalize } from "../FinalizeNoLogin";
import { useState } from "react";

export default function useFinalizeManager() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { post } = useApiRequest();
  const facilityIds = useFacility();
  const selectedSeats = useSelector((state: State) => state.basket.selectedSeats);
  const [paymentUrl, setPaymentUrl] = useState('');

  const handleBackButton = () => {
    navigate(-1);
  };

  const handleClearBasket = async () => {
    const { isError } = await post(CLEAR_BASKET_URL(facilityIds));
    if (!isError) {
      dispatch(updateSelectedSeats([]));
      dispatch(setSuccessMessage("Wyczyszczono koszyk"));
      setTimeout(() => {
        navigate(SALE_MOVIE_PAGE);
      }, 500);
    }
  };

  const onRemoveItemFromBasket = async (idx: number) => {
    const { isError } = await post(REMOVE_ITEM_BASKET_URL, { idx });
    if (!isError) {
      dispatch(updateSelectedSeats(selectedSeats.filter((item, index) => index !== idx)));
    }
  };

  const acceptTransaction = async (data: InputsFinalize) => {
    const { result, isError } = await post(ACCEPT_TRANSACTION_URL(setSaveData(data)));
    if (!isError) {
      dispatch(updateSelectedSeats([]));
      setPaymentUrl(result.PaymentURL)

     
      // window.location.href = result.PaymentURL;
    }
  };

  return {
    paymentUrl,
    handleBackButton,
    handleClearBasket,
    onRemoveItemFromBasket,
    acceptTransaction,
  };
}
